import { Button, ModalDialog, ModalOverlay } from '@flos/react-ui';
import { useHippoText } from '../../hooks/useHippoText';
import type { OnsaStep } from '../../recoil/types/onsaTypes';
import DOMPurify from 'dompurify';

const MergeBasketModal = ({
    showModal,
    closeModal,
    nextPage
}: {
    showModal: boolean;
    closeModal: () => void;
    nextPage: OnsaStep;
}): React.JSX.Element => {
    const getHippoText = useHippoText();

    const continueButtonText =
        nextPage === 'ShoppingBasketPage'
            ? getHippoText('DSS-EXISTING-BASKET-MODAL-SHOPPING-BASKET')
            : getHippoText('DSS-EXISTING-BASKET-MODAL-CONTINUE');

    return (
        <ModalOverlay isOpen={showModal}>
            <ModalDialog closeIconHandler={closeModal}>
                <div className="u-spacing-inset-l">
                    <div className="u-spacing-inset-l--stretch-max">
                        <h4 className="u-spacing-stack-sm">
                            {getHippoText('DSS-EXISTING-BASKET-MODAL-HEADER')}
                        </h4>
                        <p
                            className="u-spacing-stack-sm"
                            dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(
                                    getHippoText('DSS-EXISTING-BASKET-MODAL-DESCRIPTION')
                                )
                            }}
                        />
                    </div>
                    <Button onClick={closeModal}>{continueButtonText}</Button>
                </div>
            </ModalDialog>
        </ModalOverlay>
    );
};

export default MergeBasketModal;
